<template>
    <form class="yape-form" @submit.prevent="submitHandler">
      <div
        v-if="!$auth.check()"
        class="form-group"
        :class="{ error: $v.form.email.$error }"
      >
        <label>
          {{ $t("labels.email") }}
        </label>
        <div class="input-group">
          <input
            type="text"
            required="required"
            :placeholder="$t('placeholder.email')"
            class="form-control"
            v-model="form.email"
            @input="$v.form.email.$touch"
          />
        </div>
        <template v-if="$v.form.email.$error">
          <p class="error-message" v-if="!$v.form.email.required">
            {{ $t("validations.required", { field: $t("fields.email") }) }}
          </p>
        </template>
      </div>
      <div
        v-if="!$auth.check()"
        class="form-group"
        :class="{ error: $v.form.email_confirm.$error }"
      >
        <label>
          {{ $t("labels.email_confirm") }}
        </label>
        <div class="input-group">
          <input
            type="text"
            required="required"
            :placeholder="$t('placeholder.email_confirm')"
            class="form-control"
            v-model="form.email_confirm"
            @input="$v.form.email_confirm.$touch"
          />
        </div>
        <template v-if="$v.form.email_confirm.$error">
          <p class="error-message" v-if="!$v.form.email_confirm.required">
            {{ $t("validations.sameAs", { field: $t("fields.email") }) }}
          </p>
        </template>
      </div>

      <div
        class="form-group"
        :class="{ error: $v.form.processor.cust_phone.$error }"
      >
        <label>
          {{ $t("labels.processor.cust_phone") }}
        </label>
        <div class="input-group">
          <input
            type="number"
            required="required"
            :placeholder="$t('placeholder.processor.cust_phone')"
            class="form-control"
            :disabled="loading"
            v-model="form.processor.cust_phone"
            @input="$v.form.processor.cust_phone.$touch"
          />
        </div>
        <template v-if="$v.form.processor.cust_phone.$error">
          <p class="error-message" v-if="!$v.form.processor.cust_phone.required">
            {{
              $t("validations.required", {
                field: $t("fields.processor.cust_phone"),
              })
            }}
          </p>
        </template>
      </div>

      <div
      class="form-group"
      :class="{ error: $v.form.processor.userDocumentType.$error }"
    >
      <label>
        Tipo de documento:
      </label>

      <div class="input-group">
        <select
          required="required"
          :placeholder="$t('placeholder.processor.userDocumentType')"
          class="form-control"
          v-model="form.processor.userDocumentType"
        >
          <option value='DNI'>DNI</option>
          <option value='PAR'>PAR</option>
          <option value='PAS'>PAS</option>
          <option value='LMI'>LMI</option>
          <option value='NAN'>NAN</option>
        </select>
      </div>

    </div>

    <div
      class="form-group"
      :class="{ error: $v.form.processor.userDocumentNumber.$error }"
    >
      <label>
        {{ $t("labels.processor.userDocumentNumber") }}
      </label>
      <div class="input-group">
        <input
          type="number"
          required="required"
          :placeholder="$t('placeholder.processor.userDocumentNumber')"
          class="form-control"
          :disabled="loading"
          v-model="form.processor.userDocumentNumber"
          @input="$v.form.processor.userDocumentNumber.$touch"
        />
      </div>
      <template v-if="$v.form.processor.userDocumentNumber.$error">
        <p class="error-message" v-if="!$v.form.processor.userDocumentNumber.required">
          {{
            $t("validations.required", {
              field: $t("fields.processor.userDocumentNumber"),
            })
          }}
        </p>
      </template>
    </div>
    <div
      class="form-group"
      :class="{ error: $v.form.processor.cust_fname.$error }"
    >
      <label>
        {{ $t("labels.processor.cust_fname") }}
      </label>
      <div class="input-group">
        <input
          type="text"
          maxlength="255"
          required="required"
          :placeholder="$t('placeholder.processor.cust_fname')"
          class="form-control"
          :disabled="loading"
          v-model="form.processor.cust_fname"
          @input="$v.form.processor.cust_fname.$touch"
        />
      </div>
      <template v-if="$v.form.processor.cust_fname.$error">
        <p class="error-message" v-if="!$v.form.processor.cust_fname.required">
          {{
            $t("validations.required", {
              field: $t("fields.processor.cust_fname"),
            })
          }}
        </p>
      </template>
    </div>
    <div
      class="form-group"
      :class="{ error: $v.form.processor.cust_lname.$error }"
    >
      <label>
        {{ $t("labels.processor.cust_lname") }}
      </label>
      <div class="input-group">
        <input
          type="text"
          maxlength="255"
          required="required"
          :placeholder="$t('placeholder.processor.cust_lname')"
          class="form-control"
          :disabled="loading"
          v-model="form.processor.cust_lname"
          @input="$v.form.processor.cust_lname.$touch"
        />
      </div>
      <template v-if="$v.form.processor.cust_lname.$error">
        <p class="error-message" v-if="!$v.form.processor.cust_lname.required">
          {{
            $t("validations.required", {
              field: $t("fields.processor.cust_lname"),
            })
          }}
        </p>
      </template>
    </div>
    <div
      class="form-group"
      :class="{ error: $v.form.processor.bill_addr_country.$error }"
    >
      <label>
        {{ $t("labels.processor.bill_addr_country") }}
      </label>
      <div class="input-group">
        <select
          required="required"
          :placeholder="$t('placeholder.processor.bill_addr_country')"
          class="form-control"
          :disabled="loading"
          v-model="form.processor.bill_addr_country"
          @change="$v.form.processor.bill_addr_country.$touch"
        >
          <template v-if="countries.data">
            <option
              v-for="country in countries.data"
              :key="country.id"
              :value="country.code"
            >
              {{ country.name }}
            </option>
          </template>
          <template v-else>
            <option selected="selected" disabled="disabled" :value="null">
              <template v-if="countries.loading">
                {{ $t("loading") }}
              </template>
              <template v-if="countries.error">
                {{ $t("error") }}
              </template>
            </option>
          </template>
        </select>
      </div>
      <template v-if="$v.form.processor.bill_addr_country.$error">
        <p
          class="error-message"
          v-if="!$v.form.processor.bill_addr_country.required"
        >
          {{
            $t("validations.required", {
              field: $t("fields.processor.bill_addr_country"),
            })
          }}
        </p>
      </template>
    </div>
    <div
      v-show="stateRequired"
      class="form-group"
      :class="{ error: $v.form.processor.bill_addr_state.$error }"
    >
      <label>
        {{ $t("labels.processor.bill_addr_state") }}
      </label>
      <div class="input-group">
        <select
          required="required"
          :placeholder="$t('placeholder.processor.bill_addr_state')"
          class="form-control"
          :disabled="loading"
          v-model="form.processor.bill_addr_state"
          @change="$v.form.processor.bill_addr_state.$touch"
        >
          <template v-if="country_subdivisions.data">
            <option
              v-for="country_subdivision in country_subdivisions.data"
              :key="country_subdivision.id"
              :value="country_subdivision.code"
            >
              {{ country_subdivision.name }}
            </option>
          </template>
          <template v-else>
            <option selected="selected" disabled="disabled" :value="null">
              <template v-if="country_subdivisions.loading">
                {{ $t("loading") }}
              </template>
              <template v-if="country_subdivisions.error">
                {{ $t("error") }}
              </template>
            </option>
          </template>
        </select>
      </div>
      <template v-if="$v.form.processor.bill_addr_state.$error">
        <p
          class="error-message"
          v-if="!$v.form.processor.bill_addr_state.required"
        >
          {{
            $t("validations.required", {
              field: $t("fields.processor.bill_addr_state"),
            })
          }}
        </p>
      </template>
    </div>
    <div
      class="form-group"
      :class="{ error: $v.form.processor.bill_addr_city.$error }"
    >
      <label>
        {{ $t("labels.processor.bill_addr_city") }}
      </label>
      <div class="input-group">
        <input
          type="text"
          maxlength="255"
          required="required"
          :placeholder="$t('placeholder.processor.bill_addr_city')"
          class="form-control"
          :disabled="loading"
          v-model="form.processor.bill_addr_city"
          @input="$v.form.processor.bill_addr_city.$touch"
        />
      </div>
      <template v-if="$v.form.processor.bill_addr_city.$error">
        <p
          class="error-message"
          v-if="!$v.form.processor.bill_addr_city.required"
        >
          {{
            $t("validations.required", {
              field: $t("fields.processor.bill_addr_city"),
            })
          }}
        </p>
      </template>
    </div>
    <div
      class="form-group"
      :class="{ error: $v.form.processor.bill_addr_zip.$error }"
    >
      <label>
        {{ $t("labels.processor.bill_addr_zip") }}
      </label>
      <div class="input-group">
        <input
          type="text"
          maxlength="20"
          required="required"
          :placeholder="$t('placeholder.processor.bill_addr_zip')"
          class="form-control"
          :disabled="loading"
          v-model="form.processor.bill_addr_zip"
          @input="$v.form.processor.bill_addr_zip.$touch"
        />
      </div>
      <template v-if="$v.form.processor.bill_addr_zip.$error">
        <p
          class="error-message"
          v-if="!$v.form.processor.bill_addr_zip.required"
        >
          {{
            $t("validations.required", {
              field: $t("fields.processor.bill_addr_zip"),
            })
          }}
        </p>
      </template>
    </div>
    <div
      class="form-group"
      :class="{ error: $v.form.processor.bill_addr.$error }"
    >
      <label>
        {{ $t("labels.processor.bill_addr") }}
      </label>
      <div class="input-group">
        <input
          type="text"
          maxlength="255"
          required="required"
          :placeholder="$t('placeholder.processor.bill_addr')"
          class="form-control"
          :disabled="loading"
          v-model="form.processor.bill_addr"
          @input="$v.form.processor.bill_addr.$touch"
        />
      </div>
      <template v-if="$v.form.processor.bill_addr.$error">
        <p class="error-message" v-if="!$v.form.processor.bill_addr.required">
          {{
            $t("validations.required", {
              field: $t("fields.processor.bill_addr"),
            })
          }}
        </p>
      </template>
    </div>
      <div class="form-group" :class="{ error: $v.form.over_age.$error }">
        <label>
          <input type="checkbox" v-model="form.over_age" />
          <i18n
            path="subscription.payment_legals.accept.over_age"
            tag="span"
          ></i18n>
        </label>
        <template v-if="$v.form.over_age.$error">
          <p class="error-message" v-if="!$v.form.over_age.accepted">
            {{ $t("validations.accepted", { field: $t("fields.terms") }) }}
          </p>
        </template>
      </div>
      <div class="form-group" :class="{ error: $v.form.terms.$error }">
        <label>
          <input type="checkbox" v-model="form.terms" />
          <i18n
            path="subscription.payment_legals.accept.label_recurrent"
            tag="span"
          >
            <template>
              <a :href="termsUrl" target="_blank">{{
                $t("subscription.payment_legals.accept.terms")
              }}</a>
            </template>
            <template>
              <a :href="privacyUrl">{{
                $t("subscription.payment_legals.accept.privacy")
              }}</a>
            </template>
            <template>
              <router-link :to="{ name: 'support' }">{{
                $t("zammad_support.link")
              }}</router-link>
            </template>
          </i18n>
        </label>
        <template v-if="$v.form.terms.$error">
          <p class="error-message" v-if="!$v.form.terms.accepted">
            {{ $t("validations.accepted", { field: $t("fields.terms") }) }}
          </p>
        </template>
      </div>
  
      <ResultMessage
        v-if="resultMessage.message"
        :result-message="resultMessage"
      />
  
      <div class="buttons-container">
        <template v-if="form.accept_no_trial">
          <p class="no-trial-message">
            {{ $t("subscription.not_elegible_for_free_trial") }}
          </p>
          <button type="submit" class="btn main-btn submit">
            {{ $t("subscription.buttons.pay_without_trial") }}
          </button>
        </template>
        <template v-else-if="form.accept_no_promo">
          <p class="no-promo-message">
            {{ $t("subscription.promo_unsuported") }}
          </p>
          <button type="submit" class="btn main-btn submit">
            {{ $t("subscription.buttons.pay_without_promo") }}
          </button>
        </template>
        <template v-else>
          <button type="submit" class="btn main-btn submit">
            {{ $t("subscription.buttons.pay") }}
          </button>
        </template>
      </div>
    </form>
  </template>
  <script>
  import Spinner from "../Spinner";
  import { email, required, requiredIf } from "vuelidate/lib/validators";
  import ResultMessage from "../ResultMessage";
  import EventBus from "../../eventbus";
  import resources from "../../resources";
  
  export default {
    components: {
      Spinner,
      ResultMessage,
    },
    props: {
      purchaseOption: {
        type: Object,
        required: false,
      },
      resultMessage: {
        required: true,
      },
      hasToAcceptNoTrial: {
        required: true,
        default: false,
      },
      hasToAcceptNoPromo: {
        required: true,
        default: false,
      },
      paymentCountry: {
        required: true,
      },
    },
    data() {
      return {
        form: {
          email: "",
          email_confirm: "",
          terms: false,
          over_age: false,
          accept_no_trial: false,
          accept_no_promo: false,
          addon_legacy: true,
          payment_country_id: null,
          processor: {
            cust_fname: "",
            cust_lname: "",
            cust_phone: "",
            bill_addr: "",
            bill_addr_city: "",
            bill_addr_state: null,
            bill_addr_zip: "",
            bill_addr_country: null,
            userDocumentNumber: "",
            userDocumentType: ""
          },
        },
        countries: {
            data: null,
            loading: false,
            error: false,
        },
        country_subdivisions: {
            data: null,
            loading: false,
            error: false,
        },
      };
    },
    validations() {
      return {
        form: {
          email: {
            requiredIf: requiredIf(function () {
              //Si no esta logueado tiene que completar el email
              return !this.$auth.check();
            }),
            email,
          },
          email_confirm: {
            requiredIf: requiredIf(function () {
              //Si no esta logueado tiene que completar el email
              return !this.$auth.check();
            }),
            sameAs(value) {
              return value === this.form.email;
            },
          },
          terms: {
            accepted(value) {
              return value === true;
            },
          },
          over_age: {
            accepted(value) {
              return value === true;
            },
          },
          processor: {
            userDocumentType: {
                required,
            },
            userDocumentNumber: {
                required,
            },
            cust_fname: {
                required,
            },
            cust_lname: {
                required,
            },
            cust_phone: {
                required,
            },
            bill_addr: {
                required,
            },
            bill_addr_city: {
                required,
            },
            bill_addr_state: {
                requiredIf: requiredIf(function () {
                    return this.stateRequired;
                }),
            },
            bill_addr_zip: {
                required,
            },
            bill_addr_country: {
                required,
            },
          },
        },
      };
    },
    watch: {
      hasToAcceptNoTrial(hasToAcceptNoTrial) {
        if (hasToAcceptNoTrial === null) {
          this.form.accept_no_trial = false;
        } else {
          this.form.accept_no_trial = !!hasToAcceptNoTrial;
        }
      },
      hasToAcceptNoPromo(hasToAcceptNoPromo) {
        if (hasToAcceptNoPromo === null) {
          this.form.accept_no_promo = false;
        } else {
          this.form.accept_no_promo = !!hasToAcceptNoPromo;
        }
      },
      paymentCountry(newVal) {
        this.form.payment_country_id = newVal;
      },
      "form.processor.bill_addr_country"(countryCode) {
        this.form.processor.bill_addr_state = null;
        this.loadCountrySubdivisions(countryCode);
      },
    },
    methods: {
        loadCountries() {
            this.countries.data = null;
            this.countries.loading = true;

            resources.countries
                .index({ per_page: 9999, order_by: ["name"], include: ["is_current"] })
                .then((resp) => {
                this.countries.data = resp.data.data;
                this.countries.loading = false;
                this.countries.error = false;
                })
                .catch((err) => {
                this.countries.loading = false;
                this.countries.error = true;
                });
        },
        loadCountrySubdivisions(countryCode) {
            this.country_subdivisions.data = null;
            this.country_subdivisions.loading = false;
            this.country_subdivisions.error = false;

            if (countryCode) {
                const country = this.countries.data.find(
                (country) => country.code === countryCode
                );

                if (country) {
                this.country_subdivisions.loading = true;

                resources.country_subdivisions
                    .index({
                    country_id: country.id,
                    per_page: 9999,
                    order_by: ["name"],
                    })
                    .then((resp) => {
                    this.country_subdivisions.data = resp.data.data;
                    this.country_subdivisions.loading = false;
                    this.country_subdivisions.error = false;
                    })
                    .catch((err) => {
                    this.country_subdivisions.loading = false;
                    this.country_subdivisions.error = true;
                    });
                } else {
                this.country_subdivisions.error = true;
                }
            }
        },

      submitHandler() {
        if (this.$v.form.$invalid) {
          this.$v.form.$touch();
        } else {
          this.$emit("submit", this.form);
        }
      },
    },
    mounted() {
        this.loadCountries();
      this.form.payment_country_id = this.paymentCountry;

      if (!this.$v.form.$invalid) {
        this.$emit("submit", this.form);
      }

      EventBus.$on("addon_legacy", (value) => {
        this.form.addon_legacy = value;
      });
    },
    computed: {
      termsUrl() {
        let langCode = this.$i18n.locale;
        return `/legals/terms/${langCode}.html`;
      },
      privacyUrl() {
        return "https://divasplay.com/legals/privacy.html";
      },
      supportAddress() {
        return `soporte@divasplay.com`;
      },
      stateRequired() {
        if (!this.countries.data || !this.form.processor.bill_addr_country) {
            return true;
        }

        const country = this.countries.data.find(
            (country) => country.code === this.form.processor.bill_addr_country
        );

        if (
            !country ||
            (country &&
            this.country_subdivisions.data &&
            this.country_subdivisions.data.length !== 0)
        ) {
            return true;
        } else {
            return false;
        }
    },
    requestCountry() {
        if (!this.countries.data) {
            return null;
        } else {
            return this.countries.data.find((country) => country.is_current);
        }
    },
    },
  };
  </script>
  <style scoped lang="scss">
  @import "../../styles/variables";
  @import "../../styles/classes";
  
  .yape-form {
    text-align: center;
    margin: 30px;
    padding: 30px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
    min-width: 250px;
  
    .btn.submit {
      @extend %fresh-btn;
      font-size: 2em;
    }
  
    .legals {
      a {
        font-weight: bold;
        text-decoration: underline;
      }
  
      span {
        font-size: 0.75em;
      }
    }
  }
  </style>
  